export const enviroment = {
    api:'https://isem.disenodesalud.com.mx/api/get-images?soap=',
    // api:'https://ed3a-2806-103e-15-1e6-11d4-505d-85d6-877f.ngrok-free.app/api/get-images?soap=',
    pacs : 'https://imgmex.disenodesalud.com.mx/InnovaPacs/',
    production :  false,
    pueblaApi:'https://servicios.zdenko.com.mx/api',//'http://localhost:5000/api',
    pacsNewPuebla: 'https://ffaa805f.zdenko.com.mx/InnovaPacs/'
}































































